import { useEffect, useState } from "react";
import { useGetDropdownOptionsQuery, useGetFiEmpDepartmentQuery } from "../../services/vendor/VendorApi";
import { OptionType } from "../../utils/types";
import { SelectInput } from "../../utils/input";

const DivisionDropdown = ({ formData, handleSelectChange, isReadOnly, isMM }) => {
  const { data: dropdownList, error, isLoading, isFetching, isSuccess, isError } = useGetFiEmpDepartmentQuery(formData.invoiceForWhichLocation, { skip: formData.invoiceForWhichLocation === '' }); //useGetDropdownOptionsQuery(formData.isPoModuleSelected === "No" ? `cost_center&filter_value=${formData?.invoiceForWhichLocation}` : "division", {skip: isMM || !formData?.invoiceForWhichLocation,});

  const [selectOptions, setSelectOptions] = useState<OptionType[]>();

  useEffect(() => {
    if (isMM) {
      if (formData?.poContractDetails?.division_code) {
        const code = formData?.poContractDetails?.division_code;
        const name = formData?.poContractDetails?.division_name;
        setSelectOptions([{ value: code, label: `${code} - ${name}` }]);
        formData.divisionName = code;
      }
    } else {
      if (formData.isPoModuleSelected === "No") {
        setSelectOptions(
          dropdownList?.d?.results?.map((item) => {
            return {
              value: item?.department_id,
              label: `${item?.department_id} - ${item?.department_txt}`,
            };
          })
        );
      } else {
        setSelectOptions(
          dropdownList?.d?.results?.map((item) => {
            return {
              value: item?.ekgrp,
              label: `${item?.ekgrp} - ${item?.eknam}`,
            };
          })
        );
      }
    }
  }, [dropdownList, formData, isMM]);

  return (
    <SelectInput
      name="divisionName"
      label="Division Name"
      required
      loading={isFetching || isLoading}
      value={formData.divisionName}
      options={selectOptions || []}
      onChange={handleSelectChange}
      placeholder="Select Division Name"
      disabled={isReadOnly || isMM || (!formData?.invoiceForWhichLocation && !isMM)}
    />
  );
};

export default DivisionDropdown;
